//imports
import {
    FIRMWARE_ASSIGN_OPEN_MODAL,
    FIRMWARE_ASSIGN_GET_FIRMWARE_REQUEST,
    FIRMWARE_ASSIGN_GET_FIRMWARE_RESULT,
    FIRMWARE_ASSIGN_GET_DEVICE_REQUEST,
    FIRMWARE_ASSIGN_GET_DEVICE_RESULT,
    FIRMWARE_ASSIGN_FIRMWARE_REQUEST,
    FIRMWARE_ASSIGN_FIRMWARE_RESULT,
    FIRMWARE_ASSIGN_SET_DEVICES,
    CLEAR_REDUX,
} from "Redux/actionTypes";

//initial values
const INIT_STATE = {
    openModal: false,
    loading: false,
    device: null,
    devices: [],
    firmware: null,
    current: null,
    result: null,
};

//change redux object
export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case FIRMWARE_ASSIGN_OPEN_MODAL:
            return { ...state, openModal: true, current: action.payload }

        case FIRMWARE_ASSIGN_GET_FIRMWARE_REQUEST:
            return { ...state, loading: true }

        case FIRMWARE_ASSIGN_GET_FIRMWARE_RESULT:
            return { ...state, firmware: action.payload, loading: false }

        case FIRMWARE_ASSIGN_GET_DEVICE_REQUEST:
            return { ...state, loading: true }

        case FIRMWARE_ASSIGN_GET_DEVICE_RESULT:
            return { ...state, device: action.payload, loading: false }

        case FIRMWARE_ASSIGN_FIRMWARE_REQUEST:
            return { ...state, loading: true }

        case FIRMWARE_ASSIGN_FIRMWARE_RESULT:
            return { ...state, result: action.payload, loading: false }

        case FIRMWARE_ASSIGN_SET_DEVICES:
            return { ...state, devices: action.payload }

        case CLEAR_REDUX:
            return ["", "ASSIGN_FIRMWARE"].includes(action.payload.option)
                ? action.payload.parameters
                    ? { ...state, ...action.payload.parameters }
                    : { ...INIT_STATE }
                : { ...state };

        default:
            return state;
    }
};
